import React, { useEffect, useState, useContext } from "react";
import QRCode from "qrcode.react";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  Paper,
  Typography,
  Grid,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
}));

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const classes = useStyles();
  const [qrCode, setQrCode] = useState("");
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = user.companyId;
    // const socket = socketConnection({ companyId, userId: user.id });

    const onWhatsappData = (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);

        if (data.session.status === "CONNECTED") {
          toast.success(i18n.t("connections.toolTips.connected.title"));
          onClose();
        }
      }

      if (
        data.action === "update" &&
        data.session.qrcode === "" &&
        data.session.status === "CONNECTED"
      ) {
        onClose();
      }
    };
    socket.on(`company-${companyId}-whatsappSession`, onWhatsappData);

    return () => {
      socket.off(`company-${companyId}-whatsappSession`, onWhatsappData);
    };
  }, [whatsAppId, onClose, user.companyId, socket]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" scroll="paper">
      <DialogContent>
        <Paper elevation={0} style={{ padding: "16px" }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                gutterBottom
                color="primary"
                style={{ fontWeight: "bold" }}
              >
                Como scanear o QR Code
              </Typography>
              <div style={{ paddingLeft: "8px", marginTop: "16px" }}>
                <Typography
                  variant="body1"
                  style={{
                    color: "#555",
                    marginBottom: "16px",
                    lineHeight: "1.5",
                  }}
                >
                  <strong>1.</strong> Abra o WhatsApp no seu celular principal
                  Android.
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: "#555",
                    marginBottom: "16px",
                    lineHeight: "1.5",
                  }}
                >
                  <strong>2.</strong> Toque no ícone{" "}
                  <strong>Mais opções</strong> (três pontos na vertical) &gt;{" "}
                  <strong>Dispositivos conectados</strong> &gt;{" "}
                  <strong>Conectar dispositivo</strong>.
                </Typography>
                <Typography
                  variant="body1"
                  style={{
                    color: "#555",
                    marginBottom: "8px",
                    lineHeight: "1.5",
                  }}
                >
                  <strong>3.</strong> Aponte seu celular principal para a tela
                  do dispositivo que você deseja conectar para escanear o QR
                  code.
                </Typography>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className={classes.root}>
                {qrCode ? (
                  <QRCode
                    value={qrCode}
                    size={280}
                    style={{
                      backgroundColor: "white",
                      padding: "10px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <span>Aguardando pelo QR Code</span>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);
